import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import './index.css'
import 'isomorphic-fetch'

export default (props) => {
    const [recoveredRecords, setRecoveredRecords] = useState(false)
    useEffect(() => {
        clearLogs()
        alert('Cleared Info')
        document.location = 'https://net.awc-inc.com/formgeneric/form/tags'
    }, [])

    const clearLogs = () => {
        localStorage.setItem('AWCQueuedLogs', '[]')
        localStorage.setItem('AWCLogs', '[]')
    }

    return <div className="container"></div>
}
